<template>
  <div>
    <div v-show="isLoading">
      <div id="loading">
        <div class="loading-box">
          <div class="dot-circle">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="loading-text">{{ loadingText }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'loading',
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default:'Loading'
    }
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style>
#loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.loading-box {
  background: rgba(60, 60, 60, 0.9);
  color: white;
  border-radius: 10px;
  padding: 30px 40px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.dot-circle {
  position: relative;
  width: 40px;
  height: 40px;
  margin-bottom: 12px;
}
.dot-circle div {
  position: absolute;
  width: 10px;
  height: 10px;
  background: white;
  border-radius: 50%;
  top: 85%;
  left: 50%;
  transform-origin: 0 -14px; /* 让点排成圆环 */
  animation: fade 1.2s linear infinite;
}
.dot-circle div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.dot-circle div:nth-child(2) {
  transform: rotate(45deg);
  animation-delay: -1s;
}
.dot-circle div:nth-child(3) {
  transform: rotate(90deg);
  animation-delay: -0.9s;
}
.dot-circle div:nth-child(4) {
  transform: rotate(135deg);
  animation-delay: -0.8s;
}
.dot-circle div:nth-child(5) {
  transform: rotate(180deg);
  animation-delay: -0.7s;
}
.dot-circle div:nth-child(6) {
  transform: rotate(225deg);
  animation-delay: -0.6s;
}
.dot-circle div:nth-child(7) {
  transform: rotate(270deg);
  animation-delay: -0.5s;
}
.dot-circle div:nth-child(8) {
  transform: rotate(315deg);
  animation-delay: -0.4s;
}

@keyframes fade {
  0%,
  39%,
  100% {
    opacity: 0.3;
  }
  40% {
    opacity: 1;
  }
}

.loading-text {
  font-size: 16px;
  letter-spacing: 1px;
  font-weight: 500;
}
</style>